// extracted by mini-css-extract-plugin
export default {"root":"root_P3PE","content":"content_YXIA","image":"image_jwsx","title":"title_vMKl","subtitle":"subtitle_UdXd","cta":"cta_H9t5"};